<template>
    <div class="boxs">

        <!-- 创建分销 -->
        <div class="grayTltleLine boxs" style="margin-top:14px">
            创建分销
        </div>

        <ul class="colList">
            <li>
                <span class="col-tit">分销类型</span>
                <span class="col-span">{{distributionInfo.type}}</span>
            </li>
            <li>
                <span class="col-tit">分销名称<i>*</i></span>
                <span v-if="this.topTitle.subTit == '分销详情'" class="col-span">
          {{distributionInfo.name}}
        </span>
                <el-input maxlength="20"
                          v-if="this.topTitle.subTit != '分销详情'"
                          v-model="distributionInfo.name"
                          placeholder="输入分销的名称，不超过20个字"
                          class="width400px">
                </el-input>
            </li>
            <li v-if="this.topTitle.subTit != '分销详情'">
                <span class="col-tit">结算方式</span>
                <el-radio v-model="distributionInfo.settle_accounts_way"
                          label="1">
                    自动结算
                </el-radio>
                <el-radio v-model="distributionInfo.settle_accounts_way"
                          label="2">
                    人工结算
                </el-radio>
            </li>
            <li v-if="this.topTitle.subTit == '分销详情'">
                <span class="col-tit">结算方式</span>
                <el-radio v-model="distributionInfo.settle_accounts_way"
                          label="1"
                          disabled>
                    自动结算
                </el-radio>
                <el-radio v-model="distributionInfo.settle_accounts_way"
                          label="2"
                          disabled>
                    人工结算
                </el-radio>
            </li>
            <li class="tipsLi">
                <span class="col-tit"></span>
                <span class="col-span">自动结算：到期系统按照规则自动分账到指定会员；人工结算，则需到运营模块去审核分账。</span>
            </li>
        </ul>


    </div>
</template>

<script>
    // import {getTokenUserInfo} from '@/utils/auth'

    export default {
        name: 'CreateDistribution',
        props: {
            externalInfo: {
                required: false
            }
        },
        data() {
            return {
                distributionInfo: {
                    type: '', // 分销类型
                    name: '', // 分销名称
                    settle_accounts_way: '1', // 结算方式[1:自动结算,2:人工结算]
                },

                //标题
                topTitle: {
                    subTit: '',
                },

            }
        },
        watch: {
            externalInfo(val) {
                // console.log('val',val);
                //回显数据
                if (val) {
                    this.distributionInfo.name = val.name;
                    this.distributionInfo.settle_accounts_way = String(val.settlementType.value);
                }
            },
        },
        created() {
            // 获取上级页面携带的参数

            this.initData();
        },
        methods: {
            // 获取上级页面携带的参数
            initData() {
                if(this.externalInfo){
                    this.distributionInfo.settle_accounts_way = String(this.externalInfo.settlementType.value);
                }
                this.topTitle.subTit = this.$route.query.subTit;
                this.distributionInfo.type = this.$route.query.type;
                this.distributionInfo.name =  this.$route.query.data.name;
            },

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

    // 灰色标题
    .grayTltleLine {
        width: 100%;
        height: 32px;
        line-height: 32px;
        background: #EEEEEE;
        padding-left: 14px;
        font-size: 12px;
        font-weight: bold;
    }

    // 创建分销
    .width400px {
        width: 400px;
    }

    /* 行列 */
    .colList > li {
        margin-top: 20px;
    }

    .colList > li + li {
        margin-top: 20px;
    }

    .colList li > .col-span {
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        color: #2B2727;
    }

    li.tipsLi > .col-span {
        height: 16px;
        line-height: 16px;
        font-size: 12px;
        color: #B7B2AF;
    }

</style>
